"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSession = void 0;
const initSession = (configurationName, redirectUri, storage = sessionStorage) => {
    const saveItemsAsync = (items) => {
        storage[`oidc_items.${configurationName}:${redirectUri}`] = JSON.stringify(items);
        return Promise.resolve();
    };
    const loadItemsAsync = () => {
        return Promise.resolve(JSON.parse(storage[`oidc_items.${configurationName}:${redirectUri}`]));
    };
    const clearAsync = (status) => {
        storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens: null, status });
        return Promise.resolve();
    };
    const initAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!storage[`oidc.${configurationName}:${redirectUri}`]) {
            storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens: null, status: null });
            return { tokens: null, status: null };
        }
        const data = JSON.parse(storage[`oidc.${configurationName}:${redirectUri}`]);
        return Promise.resolve({ tokens: data.tokens, status: data.status });
    });
    const setTokens = (tokens) => {
        storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens });
    };
    const setSessionState = (sessionState) => {
        storage[`oidc.session_state.${configurationName}:${redirectUri}`] = sessionState;
    };
    const getSessionState = () => {
        return storage[`oidc.session_state.${configurationName}:${redirectUri}`];
    };
    const setNonceAsync = (nonce) => {
        localStorage[`oidc.nonce.${configurationName}:${redirectUri}`] = nonce.nonce;
    };
    const getNonceAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-ignore
        const result = { nonce: localStorage[`oidc.nonce.${configurationName}:${redirectUri}`] };
        return result;
    });
    const getTokens = () => {
        if (!storage[`oidc.${configurationName}:${redirectUri}`]) {
            return null;
        }
        return JSON.stringify({ tokens: JSON.parse(storage[`oidc.${configurationName}:${redirectUri}`]).tokens });
    };
    return {
        saveItemsAsync,
        loadItemsAsync,
        clearAsync,
        initAsync,
        setTokens,
        getTokens,
        setSessionState,
        getSessionState,
        setNonceAsync,
        getNonceAsync
    };
};
exports.initSession = initSession;
//# sourceMappingURL=initSession.js.map